'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

exports.default = withErrorLogger;

var _react = require('react');

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mason = require('../../utils/mason');

var _mason2 = _interopRequireDefault(_mason);

var _http = require('../../utils/http');

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function withErrorLogger(WrappedComponent) {
  var WithErrorLogger = function (_Component) {
    _inherits(WithErrorLogger, _Component);

    function WithErrorLogger(props) {
      _classCallCheck(this, WithErrorLogger);

      var _this = _possibleConstructorReturn(this, (WithErrorLogger.__proto__ || Object.getPrototypeOf(WithErrorLogger)).call(this, props));

      _this.state = {
        errorSent: false
      };
      return _this;
    }

    _createClass(WithErrorLogger, [{
      key: 'sendErrorLog',
      value: function sendErrorLog(_ref) {
        var cIds = _ref.cIds,
            error = _ref.error,
            errorInfo = _ref.errorInfo;
        if (this.state.errorSent || _lodash2.default.isEmpty(cIds)) return;

        _http2.default.makeCall({
          url: (0, _mason2.default)(this.props).urls.error(),
          verb: _http2.default.POST,
          data: {
            cIds: cIds,
            error: error + ' \n\n ErrorInfo:\n\n' + JSON.stringify(errorInfo)
          }
        });

        this.setState({
          errorSent: true
        });
      }
    }, {
      key: 'componentDidCatch',
      value: function componentDidCatch(error, errorInfo) {
        var _this2 = this;

        var id = this.props.id;
        this.sendErrorLog({
          cIds: [id],
          error: error,
          errorInfo: errorInfo
        });
        this.setState({
          error: error,
          errorInfo: errorInfo
        }, function () {
          var id = _this2.props.id;
          var _state = _this2.state,
              error = _state.error,
              errorInfo = _state.errorInfo;

          _this2.sendErrorLog({
            cIds: [id],
            error: error,
            errorInfo: errorInfo
          });
        });
      }
    }, {
      key: 'render',
      value: function render() {
        if (this.state.error instanceof Error) {
          return (0, _reactHyperscript2.default)('');
        }

        return (0, _reactHyperscript2.default)(WrappedComponent, this.props);
      }
    }]);

    return WithErrorLogger;
  }(_react.Component);

  WithErrorLogger.propTypes = {
    id: _propTypes2.default.string
  };
  WithErrorLogger.defaultProps = {
    id: ''
  };
  return WithErrorLogger;
}